import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

const ValuationRequestFormPage = () => {
  const [securityCode, setSecurityCode] = useState("");

  // Function to generate a 5-digit random code
  const generateCode = () => {
    return Math.floor(10000 + Math.random() * 90000).toString();
  };

  // Generate a code when the component mounts
  useEffect(() => {
    setSecurityCode(generateCode());
  }, []);

  const formik = useFormik({
    initialValues: {
      fname: "",
      lname: "",
      email: "",
      phone: "",
      address: "",
      address2: "",
      city: "",
      state: "",
      postCode: "",
      purpose: "",
      category: "",
      propertyType: "",
      valueRange: "",
      comments: "",
      securityCode: "",
    },
    validationSchema: Yup.object({
      fname: Yup.string().required("First Name is required!"),
      email: Yup.string()
        .email("Invalid email!")
        .required("Email is required!"),
      phone: Yup.string().required("Phone is required!"),
      address: Yup.string().required("Address is required!"),
      city: Yup.string().required("City is required!"),
      state: Yup.string().required("State is required!"),
      securityCode: Yup.string().required("Security code required!"),
      comments: Yup.string().required("Comments & Questions is required!"),
      purpose: Yup.string().required("Purpose is required!"),
      category: Yup.string().required("Category is required!"),
      propertyType: Yup.string().required("Property type is required!"),
      valueRange: Yup.string().required("Value range is required!"),
    }),
    onSubmit: (values) => {
      // console.log("Form Submitted:", values);
      // alert("Form submitted successfully!");
    },
  });

  const inputStyle = "border px-3 py-2 w-full rounded text-sm";
  const errorStyle = "text-sm text-red mt-1";

  return (
    <div className="px-[5vw] sm:px-[10vw] xl:px-[15vw] sm:flex-row pt-[120px] gap-5">
      <div className="bg-blue-gray-50 my-5 py-5 rounded px-3 mb:px-8">
        <h1 className="text-2xl lg:text-3xl font-playfair text-center">
          Valuation Request Form
        </h1>
        <form
          onSubmit={formik.handleSubmit}
          className="space-y-4 max-w-xl mx-auto py-5"
        >
          {/* Text Inputs */}
          {[
            ["fname", "First Name *"],
            ["lname", "Last Name"],
            ["email", "Email *"],
            ["phone", "Phone *"],
            ["address", "Address *"],
            ["address2", "Address 2"],
            ["city", "City *"],
            ["state", "State *"],
            ["postCode", "Post Code"],
          ].map(([field, label]) => (
            <div key={field}>
              <label className="block font-medium text-sm mb-1">{label}</label>
              <input
                name={field}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values[field]}
                className={inputStyle}
              />
              {formik.touched[field] && formik.errors[field] && (
                <div className={errorStyle}>{formik.errors[field]}</div>
              )}
            </div>
          ))}

          {/* Dropdowns */}
          {/* Purpose of Valuation */}
          <div>
            <label className="block font-medium text-sm mb-1">
              Purpose of Valuation *
            </label>
            <select
              name="purpose"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.purpose}
              className={inputStyle}
            >
              <option value="">Select One</option>
              <option value="pre-sale">Pre-sale/Pre-purch./Fin.</option>
              <option value="stamp-duty">Stamp Duty</option>
              <option value="gst-other">GST/Other Statutory Req.</option>
              <option value="insurance">Insurance</option>
              <option value="estate">Estate Settlement</option>
              <option value="matrimonial-in-court">
                Matrimonial Settlement - In Court
              </option>
              <option value="matrimonial-out-court">
                Matrimonial Settlement - Out of Court
              </option>
              <option value="rental-review">Rental Review</option>
              <option value="acquisition">Acquisition</option>
              <option value="other">Other</option>
            </select>
            {formik.touched.purpose && formik.errors.purpose && (
              <div className={errorStyle}>{formik.errors.purpose}</div>
            )}
          </div>

          {/* Property Category */}
          <div>
            <label className="block font-medium text-sm mb-1">
              Property Category *
            </label>
            <select
              name="category"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.category}
              className={inputStyle}
            >
              <option value="">Select One</option>
              <option value="residential">Residential</option>
              <option value="commercial">Commercial</option>
              <option value="commercial">Industrial</option>
            </select>
            {formik.touched.category && formik.errors.category && (
              <div className={errorStyle}>{formik.errors.category}</div>
            )}
          </div>

          {/* Type of Property */}
          <div>
            <label className="block font-medium text-sm mb-1">
              Type of Property *
            </label>
            <select
              name="propertyType"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.propertyType}
              className={inputStyle}
            >
              <option value="">Select One</option>
              <option value="House">House</option>
              <option value="Villa">Villa</option>
              <option value="Apartment">Apartment</option>
              <option value="Development Site">Development Site</option>
              <option value="Land & Building Contract">
                Land & Building Contract
              </option>
              <option value="Factory-Freestanding">Factory-Freestanding</option>
              <option value="Factory-Strata">Factory-Strata</option>
              <option value="Office-Freestanding">Office-Freestanding</option>
              <option value="Office-Strata">Office-Strata</option>
              <option value="Showroom-Freestanding">
                Showroom-Freestanding
              </option>
              <option value="Showroom-Strata">Showroom-Strata</option>
              <option value="Warehouse-Freestanding">
                Warehouse-Freestanding
              </option>
              <option value="Warehouse-Strata">Warehouse-Strata</option>
            </select>
            {formik.touched.propertyType && formik.errors.propertyType && (
              <div className={errorStyle}>{formik.errors.propertyType}</div>
            )}
          </div>

          {/* Approximate Value Range */}
          <div>
            <label className="block font-medium text-sm mb-1">
              Approximate Value Range *
            </label>
            <select
              name="valueRange"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.valueRange}
              className={inputStyle}
            >
              <option value="">Select One</option>
              <option value="0-300000">$0 - $300,000</option>
              <option value="301000-500000">$301,000 - $500,000</option>
              <option value="501000-750000">$501,000 - $750,000</option>
              <option value="751000-1000000">$751,000 - $1M</option>
              <option value="1000001-2000000">$1M - $2M</option>
              <option value="2000000+">$2M +</option>
            </select>
            {formik.touched.valueRange && formik.errors.valueRange && (
              <div className={errorStyle}>{formik.errors.valueRange}</div>
            )}
          </div>

          {/* Comments */}
          <div>
            <label className="block font-medium text-sm mb-1">
              Comments & Questions *
            </label>
            <textarea
              name="comments"
              rows="4"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.comments}
              className={inputStyle}
            />
            {formik.touched.comments && formik.errors.comments && (
              <div className={errorStyle}>{formik.errors.comments}</div>
            )}
          </div>

          {/* Security Code */}
          <div>
            <label className="block font-medium text-sm mb-1">
              Security Code *
            </label>
            <div className="flex items-center gap-2">
              <div className="bg-black text-white px-4 py-2 font-bold">
                {securityCode}
              </div>
              <input
                name="securityCode"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.securityCode}
                className={inputStyle}
              />
            </div>
            {formik.touched.securityCode && formik.errors.securityCode && (
              <div className={errorStyle}>{formik.errors.securityCode}</div>
            )}
          </div>

          {/* Submit / Reset Buttons */}
          <div className="flex gap-4 mt-4">
            <button
              type="reset"
              onClick={formik.handleReset}
              className="bg-red text-white px-6 py-2 rounded"
            >
              Reset
            </button>
            <button
              type="submit"
              className="bg-amber-700 text-gray px-6 py-2 rounded hover:bg-amber-900 w-full"
            >
              Submit Request
            </button>
          </div>

          <p className="text-sm mt-4 text-gray-700 italic">
            We will guarantee to beat all genuine quotes. Online request will
            receive 10% off.
          </p>
        </form>
      </div>
    </div>
  );
};

export default ValuationRequestFormPage;
